import * as React from 'react';
import { useState, useCallback } from 'react';
import SelectScreeningTool from '../components/SelectScreeningTool';
import ScreeningToolQuestions from '../components/ScreeningToolQuestions';
import { ScreeningToolType } from '../types/ScreeningTool';
import { ScreeningToolResponseCreateProps } from '../types/ScreeningToolResponse';
import { ScreeningToolResponseAnswerCreateType } from '../types/ScreeningToolResponseAnswer';
import { ScreeningToolResponseType } from '../types/ScreeningToolResponse';
import { useCreateScreeningToolResponse } from '../hooks/CreateScreeningToolResponse';
import  HeaderMinimal  from 'components/HeaderMinimal';

// APIContext for managing current screening tool and responses
export const APIContext = React.createContext({
  currentScreeningTool: null as ScreeningToolType | null,
  setCurrentScreeningTool: (screeningTool: ScreeningToolType) => {},
  screeningToolResponseAnswers: {} as Record<number, ScreeningToolResponseAnswerCreateType>,
  setScreeningToolResponseAnswers: (screeningToolResponseAnswers: ScreeningToolResponseAnswerCreateType[]) => {},
  submitScreeningToolResponse: () => {}
});

const ErrorAlert: React.FC<{ message: string }> = ({ message }) => (
  <div className="mb-4 p-3 rounded bg-red-100 border border-red-300 text-gray-800">
    {message}
  </div>
);


const ScreeningToolResponse = ({screeningTools} : {screeningTools : ScreeningToolType[]}) => {
  const { submitResponse, loading, error } = useCreateScreeningToolResponse();

  const [currentScreeningTool, setCurrentScreeningTool] = useState(null);
  const [screeningToolResponseAnswers, setScreeningToolResponseAnswers] = useState<Record<number, ScreeningToolResponseAnswerCreateType>>({});


  React.useEffect(() => {
    if (Object.keys(screeningToolResponseAnswers).length > 0) {
      submitScreeningToolResponse();
    }
  }, [screeningToolResponseAnswers]);
  
  const submitScreeningToolResponse = () => {

    const screeningToolResponse: ScreeningToolResponseCreateProps = {
      screening_tool_response: {
        screening_tool_id: currentScreeningTool?.id || 0,
        screening_tool_response_answers_attributes: Object.values(screeningToolResponseAnswers),
      }
    };

    submitResponse(screeningToolResponse)
      .then((response) => {
        if (response.data && response.data.id) {
          window.location.href = `/screening/screening_tool_response/${response.data.uuid}`;
        }
      })
  };

  const handleClose = () => {
    if (window.confirm("Are you sure you want to exit? Your progress will be lost.")) {
      window.location.href = '/';
    }
  };

  return (
    <APIContext.Provider
      value={{
        currentScreeningTool,
        setCurrentScreeningTool,
        screeningToolResponseAnswers,
        setScreeningToolResponseAnswers,
        submitScreeningToolResponse
      }}
    > 
      <HeaderMinimal fixed={true} onClose={handleClose} />
      <div className="relative max-w-xl mx-auto p-4 mt-4 md:mt-12">
        
        {error && <ErrorAlert message={error} />}
        { currentScreeningTool ? (
          <ScreeningToolQuestions screeningTool={currentScreeningTool} loading={loading} />
        ) : (
          <SelectScreeningTool screeningTools={screeningTools} />
        )}
      </div>
    </APIContext.Provider>
  );
}
export default ScreeningToolResponse;
// This is a placeholder component for the Screening Tool Response.
